<template>
  <span class="visit-link">
    <span
      class="link-text primary--text"
      @click="visitLinkOpen = !visitLinkOpen"
      ref="content">
    </span>
    <div
      class="link-url"
      v-show="visitLinkOpen">
      Visit:
      <div
        @click="openLink"
        class="link-text primary--text">{{node.attrs.href}}</div>
    </div>
  </span>
</template>

<script>
export default {
  name: 'VisitLink',
  props: ['node', 'updateAttrs'],
  data() {
    return {
      visitLinkOpen: false,
    };
  },
  methods: {
    openLink() {
      window.open(this.node.attrs.href, '_blank');
    },
    offClickClose(e) {
      if (!this.$el.contains(e.target)) {
        this.visitLinkOpen = false;
      }
    },
  },
  created() {
    document.addEventListener('click', this.offClickClose);
  },
  destroyed() {
    document.removeEventListener('click', this.offClickClose);
  },
};
</script>

<style lang="scss">
.visit-link {
  position: relative;

  .link-text {
    text-decoration: underline;
    cursor: pointer;
  }

  .link-url {
    position: absolute;
    z-index: 1;
    top: 100%;
    padding: 8px;
    left: 0;
    min-width: 200px;
    max-width: 400px;
    background-color: white;
    border-radius: 4px;
    will-change: transform;
    -webkit-box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2),
      0px 8px 10px 1px rgba(0, 0, 0, 0.14),
      0px 3px 14px 2px rgba(0, 0, 0, 0.12);
    box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2),
      0px 8px 10px 1px rgba(0, 0, 0, 0.14),
      0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  }
}
</style>
